// extracted by mini-css-extract-plugin
module.exports = {"boardAvatar":"KqK8zf5f","closeBtn":"NWCiU9Bp","boardName":"K8Bp_B8P","imgBox":"__7nvmCtiL"};